import React, { ImgHTMLAttributes, ComponentType } from 'react'
import { styled } from '../styled'
import { Box, BoxProps } from './box'

export interface Image extends BoxProps {
  url?: string
  objectFit?: string
}

export interface ImageViewProps
  extends BoxProps,
    Omit<ImgHTMLAttributes<{}>, keyof BoxProps> {
  objectFit?: string
  filter?: string
}

export const ImageView = styled(Box.withComponent('img'))`
  object-fit: ${({ objectFit = 'contain' }: ImageViewProps) => objectFit};
` as ComponentType<ImageViewProps>

export const image = ({ url, ...srcProps }: Image) =>
  Object.assign(
    function ImageInstance(props: ImageViewProps) {
      return <ImageView src={url} {...srcProps} {...props} />
    },
    { url, ...srcProps },
  )
